import * as React from 'react';
import { useAppContext } from '../../store/appContext';

export type BuildUrlWithCountry = (route?: string) => string;

interface WrappedComponentProps {
  buildUrlWithCountry: BuildUrlWithCountry;
}

// T should be type of WrappedComponent props without WrappedComponentProps fields
const withCountryCode = <T extends {}>(
  WrappedComponent: React.ComponentType<T & WrappedComponentProps>,
): React.ComponentType<T> => {
  const HocComponent: React.FC<T> = props => {
    const { countryCode } = useAppContext();

    const buildUrlWithCountry: BuildUrlWithCountry = (route = '') => {
      return `/${countryCode ? countryCode.toLowerCase() : 'us'}${route}`;
    };

    return <WrappedComponent buildUrlWithCountry={buildUrlWithCountry} {...props} />;
  };

  return HocComponent;
};

export default withCountryCode;
